export const DialogSectionHeader = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <div className="space-y-1.5">
    <h3>{children}</h3>
    <hr className="border-gray-200 dark:border-gray-700" />
  </div>
)
